// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"EnergyReductionAndGhgEquivalents_buttonsWrapper__vC9Fk"};